import { render } from "./BaseTeamMember.vue?vue&type=template&id=3d1be570&scoped=true"
import script from "./BaseTeamMember.vue?vue&type=script&lang=js"
export * from "./BaseTeamMember.vue?vue&type=script&lang=js"

import "./BaseTeamMember.vue?vue&type=style&index=0&id=3d1be570&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d1be570"]])

export default __exports__